import React from 'react';
import styled from 'styled-components';

import { imageFix } from '../../../helpers';
import './Model.css';

const Image = styled.img`
  min-width: 88px;
  min-height: 88px;
  width: auto;
  height: auto;
`;

const Circle = styled.div`
  border-radius: 50%;
  border: solid 2px var(--color-gunmetal);
  height: 88px;
  width: 88px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;
`;

function ModelPicture(props: { image: string }) {
  const image = props.image ? props.image : '';

  return (
    <Circle>
      <Image src={imageFix(image)} alt="Profile" />
    </Circle>
  );
}

export default ModelPicture;
